import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ProductsGrid from './components/ProductsGrid';
import SEOHead from '../../components/SEO/SEOHead';
import StructuredData from '../../components/SEO/StructuredData';
import { spezie, biscotti } from '../../mocks/products';

const ProdottiPage = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://agro-innovazioni.it';
  const allProducts = [...spezie, ...biscotti];
  
  const itemListData = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: 'Prodotti AGRO-INNOVAZIONI',
    description: 'Catalogo completo di spezie biologiche e biscotti biologici da tisana',
    url: `${siteUrl}/prodotti`,
    itemListElement: allProducts.map((product, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@type': 'Product',
        name: product.nome,
        description: product.descrizione,
        image: product.immagine,
        category: product.categoria,
        brand: {
          '@type': 'Brand',
          name: 'AGRO-INNOVAZIONI',
        },
      },
    })),
  };

  const webPageData = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Prodotti - Spezie e Biscotti Biologici | AGRO-INNOVAZIONI',
    description: 'Esplora il nostro catalogo di spezie biologiche certificate e biscotti artigianali da tisana. Qualità garantita e tracciabilità completa.',
    url: `${siteUrl}/prodotti`,
    mainEntity: itemListData,
  };

  return (
    <>
      <SEOHead
        title="Prodotti - Spezie Biologiche e Biscotti da Tisana | AGRO-INNOVAZIONI"
        description="Esplora il nostro catalogo di spezie biologiche certificate e biscotti artigianali da tisana. Qualità garantita e tracciabilità completa."
        keywords="spezie biologiche, biscotti biologici, catalogo prodotti bio, spezie certificate, biscotti da tisana"
        ogTitle="Prodotti - Spezie e Biscotti Biologici | AGRO-INNOVAZIONI"
        ogDescription="Esplora il nostro catalogo di spezie biologiche certificate e biscotti artigianali da tisana. Qualità garantita e tracciabilità completa."
        ogImage="https://static.readdy.ai/image/b4340cdd1673521bdb15ca49ead9cb84/f44ef6b76bca892c4b2b8ad1895f9c04.jpeg"
        ogType="website"
        canonical={`${siteUrl}/prodotti`}
      />
      <StructuredData type="WebPage" data={webPageData} />
      <StructuredData type="ItemList" data={itemListData} />
      <div className="min-h-screen bg-white">
        <Navbar />
        <main>
          <ProductsGrid />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default ProdottiPage;
